import React, {useEffect} from 'react';
import {useField} from 'formik';
import {Row} from '../../../../grid/grid-features/Row';
import {Col} from '../../../../grid/grid-features/col/Col';
import {DayTimePicker} from '../day-time-picker/DayTimePicker';

function addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function DoubleDatePicker(props) {
    const [, meta, helpers] = useField(props.fieldName);

    useEffect(() => {
        if (!meta.value || ('' + meta.value).indexOf(',') === -1) {
            let now = new Date();
            let weekago = addDays(now, -7);
            helpers.setValue(weekago.getTime() + ',' + now.getTime());
        }
    });

    let startDate = new Date();
    let endDate = new Date();

    if (meta.value && ('' + meta.value).indexOf(',') !== -1) {
        let dates = meta.value.split(',');

        startDate = new Date(parseInt(dates[0]));
        endDate = new Date(parseInt(dates[1]));
    }

    const setStartDate = (jsDate) => {
        helpers.setValue(jsDate.getTime() + ',' + endDate.getTime());
    };

    const setEndDate = (jsDate) => {
        helpers.setValue(startDate.getTime() + ',' + jsDate.getTime());
    };

    return (
        <div>
            {!props.stacked && (
                <Row>
                    <Col colsize="50">
                        <DayTimePicker
                            label="Start date"
                            raw
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                        />
                    </Col>
                    <Col colsize="50">
                        <DayTimePicker label="End date" raw selected={endDate} onChange={(date) => setEndDate(date)} />
                    </Col>
                </Row>
            )}
            {props.stacked && (
                <>
                    <DayTimePicker raw selected={startDate} onChange={(date) => setStartDate(date)} />
                    <DayTimePicker raw selected={endDate} onChange={(date) => setEndDate(date)} />
                </>
            )}
        </div>
    );
}
